import React from 'react';
import Joi from 'joi-browser';
import Form from './common/form';
import {
  getBitcoinWalletType,
  saveBitcoinWalletType,
} from '../services/bwalletTypeService';

class BitcoinWalletTypeForm extends Form {
  state = {
    data: {
      name: '',
      exchange_rate: '',
    },
    errors: {},
  };

  schema = {
    _id: Joi.string(),
    name: Joi.string().required().label('Wallet Type'),
    exchange_rate: Joi.number().required().label('Exchange Rate'),
  };

  async populateWalletType() {
    try {
      const walletTypeId = this.props.match.params.id;
      if (walletTypeId === 'new') return;

      const { data: bwtype } = (await getBitcoinWalletType(walletTypeId)).data;
      this.setState({ data: this.mapToViewModel(bwtype) });
    } catch (ex) {
      if (ex.response && ex.response.status === 404)
        return this.props.history.replace('/not-found');
    }
  }

  async componentDidMount() {
    await this.populateWalletType();
  }

  mapToViewModel(bwtype) {
    return {
      _id: bwtype._id,
      name: bwtype.name,
      exchange_rate: bwtype.exchange_rate,
    };
  }

  doSubmit = async () => {
    const { data } = this.state;
    // Call the server

    await saveBitcoinWalletType(data);

    this.props.history.push('/bwallet-types');
  };

  render() {
    const walletTypeId = this.props.match.params.id;
    return (
      <div className="row">
        <div className="col-md-6 offset-md-3" style={{ marginTop: 50 + 'px' }}>
          <div className="text-center">
            <h4
              className="h4 mb-2 login-welcome-text"
              style={{ marginTop: 20 + 'px', fontWeight: 'bold' }}
            >
              Create a Wallet Type
            </h4>
            <p style={{ color: '#000524' }}>
              This operation can only be performed by Jeroid Admin
            </p>
          </div>
          <div
            className="card card-register mx-auto mt-2"
            style={{ border: 0, borderRadius: 0, marginBottom: 10 + '%' }}
          >
            <div
              className="card-header"
              style={{
                backgroundColor: 'white',
                borderBottom: 0,
                marginTop: 2 + '%',
                fontWeight: 'bold',
              }}
            >
              Wallet Info
            </div>
            <hr
              style={{
                marginRight: 20 + 'px',
                marginLeft: 20 + 'px',
                marginTop: 0,
                marginBottom: 0,
              }}
            />
            <div className="card-body">
              <form onSubmit={this.handleSubmit}>
                <div className="form-row">
                  <div className="col-md-6">
                    {this.renderInput(
                      'name',
                      'Wallet Type',
                      '',
                      'autofocus',
                      'text'
                    )}
                  </div>
                  <div className="col-md-6">
                    {this.renderInput(
                      'exchange_rate',
                      'Exchange Rate',
                      '',
                      '',
                      'number'
                    )}
                  </div>
                </div>

                <div className="text-center">
                  {walletTypeId === 'new'
                    ? this.renderButton('Save')
                    : this.renderButton('Update')}
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default BitcoinWalletTypeForm;
